import { gql } from '@apollo/client';

const schema = {
  tasks: {
    name: 'task',
    serviceName: 'auth',
    query: gql`
      query task(
        $limit: Int
        $page: Int
        $ids: [String]
        $driver_ids: [String]
        $workshop_ids: [String]
        $site_ids: [String]
        $vehicle_ids: [String]
        $vehicle_type_ids: [String]
        $shift_type_ids: [String]
        $material_type_ids: [String]
        $operation_type_ids: [String]
        $status_ids: [String]
        $type_ids: [String]
        $contract_ids: [String]
        $created_at: String
        $min_created_at: String
        $max_created_at: String
        $min_created_at_equality: String
        $max_created_at_equality: String
        $match_location: String
        $supervisor_ids: [String]
      ) {
        task(
          limit: $limit
          page: $page
          ids: $ids
          driver_ids: $driver_ids
          workshop_ids: $workshop_ids
          site_ids: $site_ids
          vehicle_ids: $vehicle_ids
          vehicle_type_ids: $vehicle_type_ids
          shift_type_ids: $shift_type_ids
          material_type_ids: $material_type_ids
          operation_type_ids: $operation_type_ids
          status_ids: $status_ids
          type_ids: $type_ids
          contract_ids: $contract_ids
          created_at: $created_at
          min_created_at: $min_created_at
          max_created_at: $max_created_at
          min_created_at_equality: $min_created_at_equality
          max_created_at_equality: $max_created_at_equality
          match_location: $match_location
          supervisor_ids: $supervisor_ids
        ) {
          records {
            data {
              id
              status_timeline {
                created_at
                updated_at
              }
              media {
                full_url
              }
              type {
                id
                title
              }
              operation_type {
                id
                title
              }
              workshop {
                id
                title
              }
              site {
                id
                title
              }
              status {
                id
                title
              }
              vehicle {
                id
                plaque
                type {
                  id
                  title
                }
              }
              driver {
                id
                firstname
                lastname
              }
              supervisor {
                id
                firstname
                lastname
              }
              material_type {
                id
                title
              }
              baskul
              start_time
              end_time
            }
            total
          }
        }
      }
    `,
  },
  report: {
    name: 'taskReport',
    serviceName: 'auth',
    query: gql`
      query taskReport(
        $ids: [String]
        $driver_ids: [String]
        $workshop_ids: [String]
        $site_ids: [String]
        $vehicle_ids: [String]
        $vehicle_type_ids: [String]
        $shift_type_ids: [String]
        $material_type_ids: [String]
        $operation_type_ids: [String]
        $status_ids: [String]
        $type_ids: [String]
        $contract_ids: [String]
        $created_at: String
        $min_created_at: String
        $max_created_at: String
        $min_created_at_equality: String
        $max_created_at_equality: String
        $match_location: String
        $supervisor_ids: [String]
      ) {
        taskReport: task(
          ids: $ids
          driver_ids: $driver_ids
          workshop_ids: $workshop_ids
          site_ids: $site_ids
          vehicle_ids: $vehicle_ids
          vehicle_type_ids: $vehicle_type_ids
          shift_type_ids: $shift_type_ids
          material_type_ids: $material_type_ids
          operation_type_ids: $operation_type_ids
          status_ids: $status_ids
          type_ids: $type_ids
          contract_ids: $contract_ids
          created_at: $created_at
          min_created_at: $min_created_at
          max_created_at: $max_created_at
          min_created_at_equality: $min_created_at_equality
          max_created_at_equality: $max_created_at_equality
          match_location: $match_location
          supervisor_ids: $supervisor_ids
        ) {
          total_houre
          total_cubic_meter
          total_service
          total_shift
          total_tonnage
          total_tonnage_service
          all_tonnage_service
          total_cost
          all_tonnage
        }
      }
    `,
  },
  tariffs: {
    name: 'tariff',
    serviceName: 'auth',
    query: gql`
      query tariff(
        $ids: [String]
        $task_type_ids: [String]
        $material_type_ids: [String]
        $operation_type_ids: [String]
        $workshop_ids: [String]
        $site_ids: [String]
      ) {
        tariff(
          ids: $ids
          task_type_ids: $task_type_ids
          material_type_ids: $material_type_ids
          operation_type_ids: $operation_type_ids
          workshop_ids: $workshop_ids
          site_ids: $site_ids
        ) {
          data {
            id
            task_type {
              id
            }
            workshop {
              id
            }
            material_type {
              id
            }
            site {
              id
            }
            operation_type {
              id
            }
            shift_type {
              id
            }
          }
        }
      }
    `,
  },
};

export default schema;
